import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink px-5 py-14 text-center sm:px-8" data-id="element-110" data-mp="3geze367ujv27">
      <div className="mx-auto w-full max-w-2xl" data-id="element-111" data-mp="32o4b2ak1486j">
        <p className="flex items-center justify-center gap-2 font-display text-base font-extrabold uppercase tracking-tight text-white" data-id="element-112" data-mp="32pfeuadh5fxn">
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-cheer text-[11px] font-black text-white" data-id="element-113" data-mp="3uf0obca04euc">
            CR
          </span>
          Cheerleading Ready <span className="text-cheer" data-id="element-114" data-mp="36muiocgf6ul">360</span>
        </p>

        <p className="mt-4 text-sm font-semibold text-white/70" data-id="element-115" data-mp="3ldamrdmenziu">
          The #1 system for modern cheer coaches
        </p>

        <ul className="mt-6 flex items-center justify-center gap-6 text-xs font-semibold text-white/60" data-id="element-116" data-mp="3qblvtm4vm600">
          {footerLinks.map(link => <li key={link.label} data-id="element-117" data-mp="2ey05hxna5ycw">
              <a href={link.href} className="transition-colors duration-150 ease-out hover:text-white" data-id="element-118" data-mp="2ez1iw8rrqwxs">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-xl text-[11px] leading-relaxed text-white/35" data-id="element-119" data-mp="3gcts0w5j33v1">
          Skill legality and safety requirements referenced reflect the USASF All Star
          Cheer Rules as updated May 2026. Always verify your governing body's current
          season rules.
        </p>
      </div>
    </footer>;
}